<template lang="pug">
GenericCard(size='85' :scrollable='false' ignoreMaxWidth)
  .entry-detail.d-flex.flex-column
    .custom-header.d-flex.sticky-top
      CustomTab.flex-fill(
        :tabItems='tabItems'
        :tabItemsOptions='tabItemsOptions'
        v-model='selectedTab'
      )
      //- button.transparent-button(@click='emitClose')
      //-   i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

    template(v-if='selectedTab === `RECORD_DETAIL`')
      Detail.flex-fill(
        :customer='customer'
        :entryDetail='entryDetail'
        @actionPerformed='onActionPerformed'
      )
        //- @closeButtonClicked='emitClose'

    template(v-else-if='selectedTab === `RECORD_HISTORY`')
      History(
        :orderId='entryDetail.id'
        v-model='entryDetail.updated'
      )

</template>

<script>

import Detail from './tabs/Detail.vue';
import History from '@/components/history/dialogs/SellRecord/tabs/History.vue';

export default {
  props: {
    entryDetail: {
      default: () => ({}),
    },
    updated: {
      default: true,
    },
  },
  computed: {
    customer() {
      return this.entryDetail ? this.entryDetail.customer : {};
    },
  },
  watch: {
    entryDetail(newVal) {
      this.tabItemsOptions.RECORD_HISTORY = {
        showNotificationDot: newVal.updated === true,
      };
    },
  },
  data: () => ({
    tabItems: {
      RECORD_DETAIL: 'รายละเอียดรายการ',
      RECORD_HISTORY: 'ประวัติการทำรายการ',
    },
    tabItemsOptions: {},
    selectedTab: 'RECORD_DETAIL',
  }),
  async mounted() {
    this.tabItemsOptions.RECORD_HISTORY = {
      showNotificationDot: this.entryDetail.updated === true,
    };
  },
  methods: {
    // emitClose() {
    //   this.$emit('closeButtonClicked');
    // },
    onActionPerformed() {
      this.$emit('actionPerformed');
      // this.$modal.hide('action-status');
    },
  },
  components: {
    Detail,
    History,
  },
};
</script>

<style lang="scss">
.entry-detail {
  height: 95vh;
}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
